import { Box, Paper, Stack, Typography } from "@mui/material";
import React from "react";
import QrCode from "../../../../../../Images/qrCode1.png";
import moment from "moment";
import QuickTixLogoWhite from "../../../../../../Images/GX_Logo_Black_No_Bg.png";

function Ticket9({ ticket, ChangeColor, type, image, bookerName, navigator }) {
  const qrCodeData = ticket?.qrCode || "";
  const pevSelected = Number(ticket?.prevTicket) === ticket?.id ? true : false;
  return (
    <Paper
      elevation={0}
      sx={{
        backgroundColor: ChangeColor
          ? ChangeColor
          : ticket?.bgColor
          ? ticket?.bgColor
          : "#e8753c",

        display: "flex",
        justifyContent: "space-around",
        border: pevSelected ? "2px solid #4A90E2" : "0px solid #e0e0e0",
        boxShadow: pevSelected
          ? "0 4px 12px rgba(74, 144, 226, 0.5)"
          : "0 2px 8px rgba(0, 0, 0, 0.1)",
        transition: "all 0.1s ease",
        "&:hover": {
          boxShadow: "0 4px 16px rgba(0, 0, 0, 0.2)",
          border: "1px solid #4A90E2",
          borderRadius: "1px",
        },
        height: "100%",
      }}
    >
      <Stack
        alignItems={"center"}
        direction={"row"}
        width={"10%"}
        sx={{ backgroundColor: "#EBDACB" }}
        justifyContent={"center"}
      >
        <Stack
          variant="h6"
          Wrap
          component="div"
          sx={{
            fontWeight: "bold",
            fontSize: {
              xs: "2rem",
              sm: "2rem",
              md: "2rem",
              lg: "3rem",
            },
            color: "black",
            writingMode: "vertical-rl",
            transform: "rotate(180deg)",
            fontFamily: "Bebas Neue",
            padding: 0,
            margin: 0,
          }}
          textAlign={"center"}
        >
          {type ? type : ticket?.type?.[0]?.typeName ?? "VIP"}
        </Stack>
      </Stack>
      <Box
        alignItems={"center"}
        sx={{ display: "flex", flexDirection: "column" }}
        width={"25%"}
        justifyContent={"center"}
        position={"relative"}
      >
        {navigator === "ct" ? (
          <></>
        ) : !qrCodeData ? (
          <img
            src={QrCode}
            alt="qr"
            style={{
              width: "100%",
              maxWidth: "80%",
              height: "auto",
              maxHeight: "80px",
              objectFit: "contain",
            }}
          />
        ) : (
          <img
            src={ticket.qrCode || QrCode}
            alt="QR"
            style={{
              width: "100%",
              maxWidth: "100%",
              height: "auto",
              maxHeight: "100px",
              objectFit: "contain",
            }}
          />
        )}
        <Stack mt={1}>
          <Typography
            sx={{
              fontSize: {
                xs: "0.75rem",
                sm: "0.875rem",
                color: "#191919",
                fontFamily: "Lato",
              },
            }}
          >
            {ticket?.code}
          </Typography>
        </Stack>
        <img
          alt="Logo"
          src={QuickTixLogoWhite}
          style={{
            position: "absolute",
            width: "100%",
            maxWidth: "80%",
            height: "auto",
            maxHeight: "30px",
            objectFit: "contain",
            bottom: 7,
          }}
        />
      </Box>

      <Stack
        direction={"column"}
        width={"65%"}
        sx={{
          backgroundColor: ChangeColor
            ? ChangeColor
            : ticket?.bgColor
            ? ticket?.bgColor
            : "#E8753C",
        }}
      >
        <Stack
          flex={1}
          display={"flex"}
          direction={"row"}
          justifyContent={"space-between"}
          mt={3}
          sx={{ borderBottom: "3px solid rgb(255, 255, 255)" }}
          pb={1}
        >
          <img
            src={image ? image : QuickTixLogoWhite}
            alt="QR"
            style={{
              width: "25%",
              maxWidth: "80%",
              height: "auto",
              maxHeight: "85px",
              objectFit: "contain",
              marginLeft: "15px",
            }}
          />

          <Typography
            variant="body2"
            sx={{
              fontSize: {
                xs: "0.8rem",
                sm: "1rem",
                fontFamily: "Bebas Neue",
              },
            }}
            mr={"1rem"}
          >
            {moment(ticket?.date).format("MM/DD/YYYY")} &nbsp;&nbsp;&nbsp;{" "}
            {ticket?.time}
          </Typography>
        </Stack>
        <Stack
          flex={3}
          direction={"row"}
          pb={"1rem"}
          sx={{ borderBottom: "3px solid rgb(255, 255, 255)" }}
        >
          <Stack
            direction={"row"}
            flex={{ lg: 3, md: 2, sm: 2, xs: 3 }}
            my={"auto"}
          >
            <Typography
              variant="h4"
              sx={{
                fontWeight: "bold",
                fontSize: {
                  xs: "0.8rem",
                  sm: "1.6rem",
                  md: "1.8rem",
                  lg: "1.8rem",
                  my: "auto",
                },
              }}
              mt={3}
              ml={2}
            >
              {ticket?.title}
            </Typography>
          </Stack>

          <Stack alignItems={"start"} flex={1} direction={"column"}>
            <Typography
              variant="body1"
              sx={{
                fontSize: { xs: "0.6rem", sm: "0.9rem" },
                display: "flex",
                justifyContent: "flex-end",
              }}
              mr={2}
              mt={1}
              mb={2}
            >
              {ticket?.ticketName ? ticket?.ticketName : "Ticket"}
            </Typography>
            <Stack>
              <Typography
                sx={{
                  fontSize: { xs: "0.6rem", sm: "0.875rem" },
                  color: "#000000",
                  fontFamily: "Lato",
                }}
                variant="caption"
              >
                {ticket?.organizer}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { xs: "0.6rem", sm: "1rem" },
                  fontFamily: "Lato",
                }}
              >
                {bookerName}
              </Typography>
            </Stack>
          </Stack>
        </Stack>

        <Stack flex={1} direction={"row"}>
          <Stack flex={4} sx={{ borderRight: "3px solid rgb(255, 255, 255)" }}>
            <Typography
              variant="body2"
              sx={{
                fontSize: { xs: "0.7rem", sm: "0.9rem" },
                fontFamily: "Lato",
              }}
              m={1}
            >
              {ticket?.location}
            </Typography>
          </Stack>
          <Stack flex={1.5} alignItems={"center"} justifyContent={"center"}>
            <Typography
              variant="h5"
              sx={{
                fontSize: "1rem",
                whiteSpace: "nowrap",
                fontFamily: "Bebas Neue",
              }}
            >
              ${" "}
              {ticket?.price != null && ticket?.price !== ""
                ? ticket?.ticketPrices
                  ? Object.values(ticket?.ticketPrices)[0]
                  : Number(ticket?.price) === 0
                  ? "Free"
                  : Number(ticket?.price) % 1 === 0
                  ? Number(ticket?.price).toFixed(0)
                  : ticket.price
                : "211"}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Paper>
  );
}

export default Ticket9;
